export const MAP_SETTINGS_BOUNDARIES_SET_PRIMARY_BOUNDING_GROUP_ID = 'MAP_SETTINGS_BOUNDARIES_SET_PRIMARY_BOUNDING_GROUP_ID';
export const MAP_SETTINGS_BOUNDARIES_SET_ISOLATE_COLOR = 'MAP_SETTINGS_BOUNDARIES_SET_ISOLATE_COLOR';
